/* Caipi Redesign — Aussaatkalender Verkaufs-Collection.
   Monats-Selektor → Aktions-Cluster aus den ECHTEN Kategorie-Metafeldern
   (Monatslisten je Kategorie: precult/outdoor/harvest). Vanilla. */
(function () {
  'use strict';

  var MONTHS_FULL = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MONTHS_SHORT = ['JAN', 'FEB', 'MÄR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'];
  var NM = { 'januar': 1, 'februar': 2, 'märz': 3, 'maerz': 3, 'april': 4, 'mai': 5, 'juni': 6, 'juli': 7, 'august': 8, 'september': 9, 'oktober': 10, 'november': 11, 'dezember': 12 };
  function toNums(arr) { return (arr || []).map(function (s) { return NM[String(s).trim().toLowerCase()]; }).filter(Boolean); }

  // Nur datengedeckte Aktionen: Vorkultur (precult) · Aussaat ins Freiland (outdoor) · Ernte (harvest).
  // KEIN „Auspflanzen" — dafür gibt es kein Metafeld; outdoor = Aussaat, egal ob Vorzucht existiert.
  var ACTIONS = [
    { key: 'vorkultur', label: 'Noch vorziehen', desc: 'Drinnen vorziehen', color: '#8aa17a', icon: 'sun' },
    { key: 'aussaat', label: 'Aussaat ins Freiland', desc: 'Samen ins Beet säen', color: '#3e5733', icon: 'seedling' },
    { key: 'ernte', label: 'Jetzt ernten', desc: 'Reif zum Ernten', color: '#e8a429', icon: 'check' }
  ];
  var ICONS = {
    seedling: '<path d="M12 22V12M12 12c0-3-2-5-5-5 0 3 2 5 5 5zM12 12c0-3 2-6 6-6 0 4-3 6-6 6z"/>',
    leaf: '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/>',
    sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/>',
    check: '<path d="M20 6L9 17l-5-5"/>'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function has(set, m) { return set.indexOf(m) > -1; }

  function initRoot(root) {
    if (root.dataset.rdAcoInit === '1') return;
    root.dataset.rdAcoInit = '1';

    var dataEl = root.querySelector('[data-rd-aco-data]');
    var RAW = [];
    try { RAW = JSON.parse(dataEl.textContent) || []; } catch (e) { RAW = []; }
    var CATS = RAW.map(function (c) {
      return {
        label: c.label, emoji: c.emoji, img: c.img || '', count: c.count || 0, url: c.url || '',
        precult: toNums(c.precult), outdoor: toNums(c.outdoor), harvest: toNums(c.harvest)
      };
    }).filter(function (c) { return c.precult.length || c.outdoor.length || c.harvest.length; });
    if (!CATS.length) return;

    var monthsWrap = root.querySelector('[data-rd-aco-months]');
    var clustersEl = root.querySelector('[data-rd-aco-clusters]');
    var banner = root.querySelector('[data-rd-aco-banner]');
    var popH = root.querySelector('[data-rd-aco-pop-h]');

    var month = (new Date()).getMonth() + 1;

    function clustersFor(m) {
      var out = { vorkultur: [], aussaat: [], ernte: [] };
      CATS.forEach(function (c) {
        if (has(c.precult, m)) out.vorkultur.push(c);      // Vorzucht-Fenster läuft (x_aussaat_vorkultur)
        if (has(c.outdoor, m)) out.aussaat.push(c);        // Freiland-Aussaat (x_aussaat) — kein Auspflanz-Datum vorhanden
        if (has(c.harvest, m)) out.ernte.push(c);          // Erntefenster (x_ernte)
      });
      return out;
    }
    function sowableCount(cl) {
      var seen = {}, n = 0;
      ['vorkultur', 'aussaat'].forEach(function (k) {
        cl[k].forEach(function (c) { if (!seen[c.label]) { seen[c.label] = 1; n++; } });
      });
      return n;
    }
    function shortLabel(k) { return k === 'vorkultur' ? 'Vorkultur' : (k === 'aussaat' ? 'Aussaat' : 'Ernte'); }
    function svg(name) { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[name] || '') + '</svg>'; }
    function setText(sel, t) { var el = root.querySelector(sel); if (el) el.textContent = t; }

    function render() {
      var cl = clustersFor(month);
      [].forEach.call(monthsWrap.querySelectorAll('.rd-aco__month'), function (b) {
        var mi = parseInt(b.getAttribute('data-month'), 10);
        var on = mi === month;
        b.classList.toggle('is-active', on);
        var nEl = b.querySelector('[data-rd-aco-month-n]');
        if (nEl) nEl.textContent = on ? (sowableCount(clustersFor(mi)) + ' Sorten') : '';
      });
      var nSow = sowableCount(cl);
      var parts = [];
      ['vorkultur', 'aussaat'].forEach(function (k) { if (cl[k].length) parts.push(cl[k].length + ' ' + shortLabel(k)); });
      if (banner) {
        setText('[data-rd-aco-banner-badge]', MONTHS_SHORT[month - 1]);
        setText('[data-rd-aco-banner-eye]', 'Im ' + MONTHS_FULL[month - 1] + ' machbar');
        setText('[data-rd-aco-banner-h]', nSow > 0 ? (nSow + ' Saatgut-Kategorien für jetzt') : 'Gartenpause');
        setText('[data-rd-aco-banner-sub]', parts.length ? parts.join(' · ') : 'Im ' + MONTHS_FULL[month - 1] + ' ruht der Garten — perfekt zum Planen.');
      }
      if (popH) popH.textContent = 'Beliebt im ' + MONTHS_FULL[month - 1];
      var html = '';
      ACTIONS.forEach(function (a) {
        var items = cl[a.key];
        if (!items.length) return;
        html += '<div class="rd-aco__cluster" style="--c:' + a.color + '">'
          + '<div class="rd-aco__cluster-head"><span class="rd-aco__cluster-ico">' + svg(a.icon) + '</span>'
          + '<span class="rd-aco__cluster-meta"><span class="rd-aco__cluster-l">' + esc(a.label) + '</span>'
          + '<span class="rd-aco__cluster-desc">' + esc(a.desc) + ' · ' + items.length + ' Kategorien</span></span></div>'
          + '<div class="rd-aco__cats">';
        items.forEach(function (c) {
          var n = c.count > 0 ? ('<span class="rd-aco__cat-n">' + c.count + ' Sorten</span>') : '';
          var ico = c.img
            ? '<img class="rd-aco__cat-img" src="' + esc(c.img) + '" alt="' + esc((c.label || 'Saatgut') + ' Samen') + '" loading="lazy">'
            : esc(c.emoji || '🌱');
          html += '<a class="rd-aco__cat" href="' + esc(c.url || '#') + '">'
            + '<span class="rd-aco__cat-ico' + (c.img ? ' rd-aco__cat-ico--img' : '') + '">' + ico + '</span>'
            + '<span class="rd-aco__cat-l">' + esc(c.label) + '</span>' + n + '</a>';
        });
        html += '</div></div>';
      });
      if (!html) html = '<p class="rd-aco__empty">Im ' + MONTHS_FULL[month - 1] + ' ist klassische Gartenpause. Schau dir die Saison-Sorten unten an oder plane mit dem Aussaatkalender.</p>';
      clustersEl.innerHTML = html;
    }

    monthsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.rd-aco__month');
      if (!b) return;
      month = parseInt(b.getAttribute('data-month'), 10);
      render();
      b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    });

    render();
    var act = monthsWrap.querySelector('.rd-aco__month.is-active');
    if (act) act.scrollIntoView({ inline: 'center', block: 'nearest' });
  }

  function init() { document.querySelectorAll('[data-rd-aco]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
